import { AxiosError } from 'axios';

import { MutationFn } from '@percent/hosted-validation-form/hooks/useMutation/useMutation.types';
import { ClientResponse } from '../types/types';

export type SendOtpArguments = {
  validationInviteId: string;
  email: string;
  firstName: string;
};

export type SendOtpBody = Omit<SendOtpArguments, 'validationInviteId'>;

export type VerifyOtpArguments = {
  validationInviteId: string;
  email: string;
  code: string;
};

export type VerifyOtpBody = Omit<VerifyOtpArguments, 'validationInviteId'>;

export type VerifyOtpResponse = {
  data: {
    token: string;
  };
};

export const sendOtpAction: MutationFn<SendOtpArguments, ClientResponse<void>, AxiosError, SendOtpBody> = ({
  validationInviteId,
  ...body
}) => {
  return {
    endpoint: `v1/validation-invites/${validationInviteId}/otp/send`,
    method: 'POST',
    params: body,
  };
};

export const verifyOtpAction: MutationFn<
  VerifyOtpArguments,
  ClientResponse<VerifyOtpResponse>,
  AxiosError,
  VerifyOtpBody
> = ({ validationInviteId, ...body }) => {
  return {
    endpoint: `v1/validation-invites/${validationInviteId}/otp/verify`,
    method: 'POST',
    params: body,
  };
};
